// extracted by mini-css-extract-plugin
export default {"cls1":"As1vess2qzfji_iTsS0u","cls2":"MMxJ6wxkWyU2LrP47HME As1vess2qzfji_iTsS0u"};